import { userHasRole } from "composables/useHelpers";
import { USER_ROLES } from "shared/constants";

const BEACON_ID = "5c347d4e-9785-404b-99fb-3ff577fd4deb";
const BEACON_SCRIPT_ID = "beacon-script";

type BeaconCall = { method: string; options?: unknown; data?: unknown };

type BeaconFn = ((
  method: string,
  options?: unknown,
  data?: unknown,
) => void) & { readyQueue: BeaconCall[] };

declare global {
  interface Window {
    Beacon?: BeaconFn;
  }
}

/**
 * Loads the Help Scout Beacon widget for webmasters only.
 *
 * Queues calls on `window.Beacon.readyQueue` until beacon-v2 has loaded and
 * replaces the stub — the contract of Help Scout's own embed snippet.
 */
export const useHelpScoutBeacon = () => {
  const initialize = (): void => {
    if (userHasRole([USER_ROLES.WEBMASTER]) === false) {
      return;
    }

    if (document.getElementById(BEACON_SCRIPT_ID) !== null) {
      return;
    }

    const beacon = ((method, options, data) => {
      beacon.readyQueue.push({ method, options, data });
    }) as BeaconFn;

    beacon.readyQueue = [];
    window.Beacon = beacon;

    const script = document.createElement("script");
    script.id = BEACON_SCRIPT_ID;
    script.async = true;
    script.src = "https://beacon-v2.helpscout.net";
    document.head.appendChild(script);

    window.Beacon("init", BEACON_ID);
  };

  return { initialize };
};
